import { h } from 'preact'
import { PredictiveSearchResponse } from './instant-search.types'
import { useEffect, useState } from 'preact/hooks'

interface InstantSearchCollectionsProps {
  'search-term'?: string
}

interface Collection {
  handle: string
  title: string
  url: string
}

export function InstantSearchCollections({ 'search-term': searchTerm }: InstantSearchCollectionsProps) {
  const [collections, setCollections] = useState<Collection[]>([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (!searchTerm || searchTerm.length < 3) {
      setCollections([])
      return
    }

    const fetchCollections = async () => {
      setIsLoading(true)
      try {
        const predictiveSearchUrl = (window as any).gmState?.routes?.predictive_search_url || '/search/suggest'
        const params = new URLSearchParams({
          q: searchTerm,
          'resources[type]': 'collection',
          'resources[limit]': '4'
        })

        const response = await fetch(`${predictiveSearchUrl}.json?${params.toString()}`)
        if (!response.ok) throw new Error('Search failed')

        const data: PredictiveSearchResponse = await response.json()
        const collectionsData = data.resources.results.collections || []
        setCollections(collectionsData)
      } catch (error) {
        console.error('Collection search error:', error)
        setCollections([])
      } finally {
        setIsLoading(false)
      }
    }

    fetchCollections()
  }, [searchTerm])

  useEffect(() => {
    window.dispatchEvent(new CustomEvent('instant-search:collections-updated', {
      detail: { count: collections.length, searchTerm: searchTerm || '', isLoading }
    }))
  }, [collections, searchTerm, isLoading])

  if (!searchTerm || searchTerm.length < 3 || collections.length === 0) {
    return null
  }

  return (
    <div class="flex flex-col gap-y-1.25 relative pb-2.125 last:pb-0">
      <h3 class="h4 font-medium">Suggested Collections</h3>
      <div class="flex flex-col flex-grow gap-y-1.25 w-full">
        {collections.map(collection => (
          <a href={collection.url} class="group w-fit" aria-label={collection.title} key={collection.handle}>
            <span class="paragraph-s font-450 w-fit paragraph-b first-letter:capitalize">
              {collection.title}
            </span>
          </a>
        ))}
      </div>
    </div>
  )
}
